import { render, staticRenderFns } from "./subsidyListDetail.vue?vue&type=template&id=07a50397&scoped=true"
import script from "./subsidyListDetail.vue?vue&type=script&lang=js"
export * from "./subsidyListDetail.vue?vue&type=script&lang=js"
import style0 from "./subsidyListDetail.vue?vue&type=style&index=0&id=07a50397&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a50397",
  null
  
)

export default component.exports